import React from "react";
import PatientCard from "./PatientCard";
import "../styles/components/Result.scss";
import MessageBox from "./MessageBox";

const SearchResult = (props: any) => {
  return (
    <div className="result">
      {props.data.length > 0 ? (
        <>
          {props.data.map((patient: any, index: number) => {
            return (
              <div className="mb-4" key={`result-${index}`}>
                <PatientCard data={patient} />
              </div>
            );
          })}
        </>
      ) : (
        <MessageBox message_key="no_result" />
      )}
    </div>
  );
};

export default SearchResult;
